import {
  FiltroServicosSemPrestadorModel,
  SolicitacaoSemPrestadorModel,
  FiltroServicosModel,
  SolicitacaoModel,
  ServicoDetalhadoModel
} from "@/models/solicitacoes";
import ResultadoServicosModel from "@/models/solicitacoes/ResultadoServicosModel";
import ResultadoServicosSemPrestadorModel from "@/models/solicitacoes/ResultadoServicosSemPrestadorModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { servicoService } from "@/service/ServicoService";

import store from "@/store";
import {
  getModule,
  Module,
  Mutation,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";
import { tipoServicoVeicularList } from '@/models/commons/TipoServicoModel';
import { PaginationModel } from "@/models/commons/PaginationModel";
import moment from "moment";

export interface IServicoModule {
  resultadoSolicitacoes: ResultadoServicosModel;
  servicoDetalhado: ServicoDetalhadoModel;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "solicitacao",
})
class ServicoModule extends VuexModule {
  resultadoSolicitacoes: ResultadoServicosModel | null = null;
  resultadoSolicitacoesSemPrestador: ResultadoServicosSemPrestadorModel | null = null;
  servicoDetalhado: ServicoDetalhadoModel | null = null;

  @Mutation
  SET_RESULTADO_SOLICITACOES_SEM_PRESTADOR(payload: ResultadoServicosSemPrestadorModel) {
    this.resultadoSolicitacoesSemPrestador = payload;
  }

  @Mutation
  SET_RESULTADO_SOLICITACOES(payload: ResultadoServicosModel) {
    this.resultadoSolicitacoes = payload;
  }

  @Mutation
  SET_SERVICO_DETALHADO(payload: ServicoDetalhadoModel) {
    this.servicoDetalhado = payload;
  }

  @MutationAction({ mutate: ["resultadoSolicitacoes"], rawError: true })
  async obterSolicitacoes(filtro: FiltroServicosModel) {

    let resultado = undefined;

    try {
       resultado = await ServicosAssistenciaService
          .pesquisarPrestadorAssistenciaServicos(filtro);

    } catch (error) {
      console.error(error);
    }
    
    return {
      resultadoSolicitacoes: {
        servicos: resultado?.servicos.map((s) => {
          
          return new SolicitacaoModel(
            s.idServico,
            s.numeroServico,
            s.data,
            tipoServicoVeicularList.find(t=> t.name == s.tipoServico)?.descricao || s.tipoServico ,
            s.statusSolicitacaoPrestador,
            s.valor,
            s.statusServico,
            s.idPrestador,
            s.nomePrestador,
            s.nomeCliente,
            s.cpfCnpjPrestador,
            s.aceitaReenvioSolicitacao
          );
        }),
        paginacao: {
          itemsLength: resultado?.pagination.totalElements,
        },
      },
    };
  }

  @MutationAction({ mutate: ["resultadoSolicitacoes"], rawError: true })
  async obterNovasSolicitacoes(filtro: FiltroServicosModel) {

    let resultado = undefined;

    try {
       resultado = await ServicosAssistenciaService
          .pesquisarServicosAssistencia(filtro);

    } catch (error) {
      console.error(error);
    }
    
    return {
      resultadoSolicitacoes: {
        servicos: resultado?.servicos.map((s) => {
          
          return new SolicitacaoModel(
            s.idServico,
            s.numeroServico,
            s.data,
            tipoServicoVeicularList.find(t=> t.name == s.tipoServico)?.descricao || s.tipoServico ,
            s.statusSolicitacaoPrestador,
            s.valor,
            s.statusServico,
            s.idPrestador,
            s.nomePrestador,
            s.nomeCliente,
            s.cpfCnpjPrestador,
            s.aceitaReenvioSolicitacao,
            undefined
          );
        }),
        paginacao: {
          itemsLength: resultado?.pagination.totalElements,
        },
      },
    };
  }

  @MutationAction({ mutate: ["resultadoSolicitacoesSemPrestador"], rawError: true })
  async obterSolicitacoesSemPrestadores(filtro: FiltroServicosSemPrestadorModel) {

    let resultado = undefined;

    try {
       resultado = await ServicosAssistenciaService
          .pesquisarServicosSemPrestador(filtro);

    } catch (error) {
      console.error(error);
    }
    
    return {
      resultadoSolicitacoesSemPrestador: {
        servicos: resultado?.servicos.map((s) => {
          return new SolicitacaoSemPrestadorModel(
            s.idServico,
            s.nomeCliente,
            s.nomeSolicitante,
            s.telefone,
            s.email,
            s.enderecoCompleto,
            s.dataCriacao,
            tipoServicoVeicularList.find(t=> t.name == s.tipoServico)?.descricao || s.tipoServico ,
          );
        }),
        paginacao: {
          itemsLength: resultado?.pagination.totalElements,
        },
      },
    };
  }

  @MutationAction({ mutate: ["servicoDetalhado"], rawError: true })
  async obterSolicitacaoDetalhada(idServico: number) {
    const servicoDetalhado = await servicoService.obterServicoDetalhado(
      idServico
    );
    return {
      servicoDetalhado,
    };
  }

}

export const servicoModule: ServicoModule = getModule(ServicoModule);
